<template>
  <div>
    <center> <img :src="dataD['imgUrl']" style="width: 100%;margin-bottom:-3px"></center>
    <div class="introduce-bg">
      <div style="max-width: 1000px;margin: 0 auto;">
        <span></span>
        <h2> 关于我们 </h2>
        <span></span>
        <p style="text-align:center;text-indent: 0em;"> ABOUT US </p>
        <p style="white-space: pre-wrap;">{{dataD['synopsis']}}</p>
        </div>



    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataD:[]
    };
  },
  created() {
    this.$http.get("api/vue_config/about_us").then((response) => {
      // console.log(response.data.data)
      this.dataD = JSON.parse(response.data.data)
    });

  },

};
</script>

<style lang="less" scoped>

.introduce-bg{

  background-color: #fff;
  text-align:center;
  color: #777;
  font-family: '微软雅黑';
  min-height: 350px;
  h2{
    font-size: 30px;
  }
  p{
    // text-indent: 2em;
    font-size: 20px;
    text-align:left;
    line-height: 40px;
  }
  span{
    display: inline-block;
    width: 250px;
    border-top: 1px solid #000 ;

  }
}

</style>
